import { observer } from 'mobx-react-lite';

import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { OverlayingPopup } from '@gem/ui-kit';

import { Sticker } from 'APP/components/Sticker/Sticker';
import {
  STICKER_FULL_SCREEN_MAX_HEIGHT,
  STICKER_FULL_SCREEN_MAX_WIDTH,
} from 'APP/constants/stickers';

import usePresenter from './presenter';
import styles from './styles.m.scss';

const StickerPopup = () => {
  const { sticker, onClose, displayUILayer } = usePresenter();
  return (
    <>
      <AddKeyPressHandler onEsc={onClose} />
      <OverlayingPopup
        isOpened
        onClose={onClose}
        className={styles.overlay}
        popupClassName={styles.container}
      >
        <div
          key={sticker.id}
          className={styles.translateContainer}
          style={{
            transform: `translate(${sticker.translate.left}px, ${sticker.translate.top}px)`,
          }}
        >
          <Sticker
            key={sticker.id}
            className={styles.sticker}
            displayUILayer={displayUILayer}
            sticker={sticker}
            maxWidth={STICKER_FULL_SCREEN_MAX_WIDTH}
            maxHeight={STICKER_FULL_SCREEN_MAX_HEIGHT}
            autoplay
          />
        </div>
      </OverlayingPopup>
    </>
  );
};

export default observer(StickerPopup);
